export const isTodayOrFuture = (date: Date) => {
	const today = new Date()
	today.setHours(0, 0, 0, 0)

	return date.getTime() >= today.getTime()
}
